export const matchesPhoneNumber = (): RegExp =>
	/^([(]=?([2-9]{1} *[\d]{1} *[\d]{1})[)]|([2-9]{1} *[\d]{1} *[\d]{1})|(([2-9]{1} *[\d]{1} *[\d]{1}[-]))) *([\d]{3}( {1}|-{1})?[\d]{4}) *$/

export const matchesEmail = (): RegExp =>
	/^[a-zA-Z0-9._-]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/i

export const matchesZipCode = (): RegExp => /(^\d{5}$)|(^\d{5}-\d{4}$)/
